/* VIVIASKIN theme — shared behavior (topbar shrink + scroll reveals) */
(function () {
  function motionOff() {
    if (window.vivMotionOff) return window.vivMotionOff();
    return matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initTopbar() {
    var bar = document.getElementById('topbar');
    if (!bar) return;
    // --header-h drives how far the hero pulls up under the transparent bar.
    // The real height varies with viewport (and shrank with the inline
    // wordmark), so measure it instead of trusting the CSS constant —
    // otherwise the hero overshoots and covers the announcement bar.
    var setHeaderH = function () {
      if (bar.classList.contains('scrolled')) return; // measure at-rest only
      var h = bar.offsetHeight;
      if (h > 0) document.documentElement.style.setProperty('--header-h', h + 'px');
    };
    setHeaderH();
    window.addEventListener('resize', setHeaderH, { passive: true });
    var update = function () {
      var was = bar.classList.contains('scrolled');
      var now = window.scrollY > 8;
      bar.classList.toggle('scrolled', now);
      // re-measure once the shrink transition has settled back at rest
      if (was && !now) setTimeout(setHeaderH, 400);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  var io;
  function observeReveals(root) {
    if (!('IntersectionObserver' in window)) {
      (root || document).querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    }
    (root || document).querySelectorAll('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
  }

  function initCursorHalo() {
    if (!document.body.hasAttribute('data-cursor-halo')) return;
    if (!matchMedia('(pointer: fine)').matches) return;
    if (motionOff()) return;

    document.body.classList.add('halo-on');

    var halo = document.createElement('div');
    halo.className = 'cursor-halo';
    halo.setAttribute('aria-hidden', 'true');
    var dot = document.createElement('div');
    dot.className = 'cursor-dot';
    dot.setAttribute('aria-hidden', 'true');
    document.body.appendChild(halo);
    document.body.appendChild(dot);

    var tx = -100, ty = -100, x = -100, y = -100;
    var shown = false;

    document.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      dot.style.left = tx + 'px';
      dot.style.top = ty + 'px';
      var overText = e.target.closest && e.target.closest('input, textarea');
      if (overText) {
        shown = false;
        dot.classList.remove('visible');
        halo.classList.remove('visible');
        return;
      }
      if (!shown) {
        shown = true; x = tx; y = ty;
        dot.classList.add('visible');
        halo.classList.add('visible');
      }
      var el = e.target.closest && e.target.closest('a, button, summary, select, [role="button"]');
      halo.classList.toggle('active', !!el);
      var dark = e.target.closest && e.target.closest('.site-footer, .announce, .hero-cine:not(.art-mode)');
      dot.classList.toggle('inverted', !!dark);
      halo.classList.toggle('inverted', !!dark);
    }, { passive: true });

    document.addEventListener('mouseleave', function () {
      shown = false;
      dot.classList.remove('visible');
      halo.classList.remove('visible');
    });

    (function loop() {
      x += (tx - x) * 0.22;
      y += (ty - y) * 0.22;
      halo.style.left = x + 'px';
      halo.style.top = y + 'px';
      requestAnimationFrame(loop);
    })();
  }


  function initHeroMotion() {
    if (motionOff()) return;
    var h1 = document.querySelector('.hero-content h1');
    if (h1 && !h1.classList.contains('split')) {
      var delay = 0.35;
      var wrap = function (node) {
        if (node.nodeType === 3) {
          var frag = document.createDocumentFragment();
          node.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var s = document.createElement('span');
            s.className = 'w';
            s.textContent = part;
            s.style.animationDelay = delay.toFixed(2) + 's';
            delay += 0.09;
            frag.appendChild(s);
          });
          node.parentNode.replaceChild(frag, node);
        } else if (node.nodeType === 1) {
          Array.prototype.slice.call(node.childNodes).forEach(wrap);
        }
      };
      Array.prototype.slice.call(h1.childNodes).forEach(wrap);
      h1.classList.add('split');
      var after = [
        ['.hero-content .eyebrow', 0.15],
        ['.hero-content .lead', 1.35],
        ['.hero-content .hero-ctas', 1.6],
        ['.hero-tagline', 2.0]
      ];
      after.forEach(function (pair) {
        var el = document.querySelector(pair[0]);
        if (el) { el.classList.add('h-rise'); el.style.animationDelay = pair[1] + 's'; }
      });
    }
  }

  function init() {
    initTopbar();
    observeReveals(document);
    initCursorHalo();
    initHeroMotion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when the theme editor injects or re-renders a section */
  document.addEventListener('shopify:section:load', function (e) {
    observeReveals(e.target);
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  });
})();
